<template>
  <tr>
    <td>{{ place }}</td>
    <td>{{ distance }}</td>
  </tr>
</template>

<script>
export default {
  name: 'TrafficLocationsResultItem',

  props: {
    place: String,
    distance: Number
  }
}
</script>
